(ns practitest.frontend.routing.routes
  (:require
    [practitest.frontend.account-dashboard-settings.main :as account-dashboard-settings-main]
    [practitest.frontend.common.utils :refer [development-only]]
    [practitest.frontend.components.usage-and-limits :as usage-and-limits]
    [practitest.frontend.users-view.views :as users-view]
    [practitest.frontend.et.main :as et-main]
    [practitest.frontend.forms3.requirements :as requirements]
    [practitest.frontend.global-fields-settings.main :as global-fields-settings-main]
    [practitest.frontend.issues :as issues]
    [practitest.frontend.issues.index :as issues-index]
    [practitest.frontend.kanban.main :as kanban-main]
    [practitest.frontend.landing.main :as landing-main]
    [practitest.frontend.login.events :as login-events]
    [practitest.frontend.login.views :as login-views]
    [practitest.frontend.login.reset-password-views :as reset-password-views]
    [practitest.frontend.signup.events :as signup-events]
    [practitest.frontend.signup.views :as signup-views]
    [practitest.frontend.oauth-authorization.views :as oauth-views]
    [practitest.frontend.permission-error.views :as permission-error-views]
    [practitest.frontend.user-link-result.views :as user-link-result-views]
    [practitest.frontend.milestones :as milestones]
    [practitest.frontend.forms3.instance :as instance]
    [practitest.frontend.forms3.run :as run]
    [re-frame.core :as re-frame]
    [practitest.frontend.permutations.main :as permutations-main]
    [practitest.frontend.project-history :as project-history]
    [practitest.frontend.reports.main :as reports-main]
    [practitest.frontend.requirements.index :as requirements-index]
    [practitest.frontend.routing.router :as router]
    [practitest.frontend.search.main :as search-main]
    [practitest.frontend.sections :as sections]
    [practitest.frontend.subs :as subs]
    [practitest.frontend.tests.index :as tests-index]
    [practitest.frontend.tests.test-form :as test-form]
    [practitest.frontend.testset2 :as testset2]
    [practitest.frontend.testset2.index :as testset-index]
    [practitest.frontend.project-fields-settings.main :as project-fields-settings-main]))


;; Passed from backend, stored in atom to work with hot reload
(defonce router-configuration (atom {}))

;; Backend-compatible routes here
(defn build-rails-routes
  [config]
  [""
   ["/login"
    {:name        :login
     :view        login-views/login-page
     :controllers [{:start (fn [_] (re-frame/dispatch [::login-events/init]))}]}]

   ["/login/password"
    {:name        :login-password
     :view        login-views/login-page
     :controllers [{:start (fn [_] (re-frame/dispatch [::login-events/set-password-step]))}]}]

   ["/forgot_password"
    {:name        :forgot-password
     :view        login-views/forgot-password-page
     :controllers [{:start (fn [_] (re-frame/dispatch [::login-events/init-forgot]))}]}]

   ["/reset_password/:code"
    {:name        :reset-password
     :conflicting true
     :view        reset-password-views/reset-password-page
     :controllers [{:identity (fn [match] match)
                    :start (fn [match]
                             (re-frame/dispatch [::login-events/init-reset-password
                                                (get-in match [:path-params :code])
                                                (get-in match [:query-params :email])]))}]}]

   ["/signups/new"
    {:name        :signup-new
     :view        signup-views/new-signup-page
     :controllers [{:start (fn [_] (re-frame/dispatch [::signup-events/init]))}]}]

   ["/signups/:code/edit"
    {:name        :signup-edit
     :view        signup-views/signup-page
     :controllers [{:identity (fn [match] match)
                    :start    (fn [match]
                                (re-frame/dispatch [::signup-events/init
                                                     (get-in match [:path-params :code])]))}]}]

   ["/no-project"
    {:name :no-project
     :view login-views/no-project-page}]

   ["/user-without-project"
    {:name :user-without-project
     :view login-views/user-without-project-page}]

   ["/permission_error"
    {:name :permission-error
     :view permission-error-views/permission-error-page}]

   ["/oauth/authorize"
    {:name :oauth-authorization
     :view oauth-views/oauth-authorization-page}]

   ["/integrations/user_link_result"
    {:name :user-link-result
     :view user-link-result-views/user-link-result-page}]

   ["/:account-id/landing"
    {:name ::landing-main/landing
     :conflicting true
     :view landing-main/landing-view
     :controllers [landing-main/main-controller]
     :extractors [(fn [db] {:account-id (subs/get-current-account-id db)})]}]

   ;; Extractors will provide base context
   (let [project-extractor (fn [db]
                             {:project-id (subs/get-current-project-id db)
                              :account-id (subs/get-current-account-id db)})
         ;; every subroute will need project-id
         base-info {:extractors [project-extractor]}]
     [["/accounts/:account-id"
       ["/dashboard_settings"
        (merge base-info
               {:name ::account-dashboard-settings-main/dashboard_setting
                :force-reload? true
                :view account-dashboard-settings-main/account-dashboard-settings-view})]
       ["/usage_and_limits"
        (merge base-info
               {:name ::usage-and-limits/usage-and-limits
                :view usage-and-limits/usage-and-limits-view
                :controllers [usage-and-limits/main-controller]})]
       ["/users_view"
        (merge base-info
               {:name ::users-view/users-view
                :view users-view/users-view-page
                :controllers [users-view/main-controller]})]
       ["/global_fields"
        ["" 
         (merge base-info
                   {:name ::global-fields-settings-main/global_fields_setting
                    :force-reload? true
                    :view global-fields-settings-main/global-fields-settings-view})]
        ["/new"
         (merge base-info
                   {:name ::global-fields-settings-main/new
                    :view global-fields-settings-main/new
                    :controllers [(global-fields-settings-main/form-controller)]})]
        ["/edit/:global-field-id"
         (merge base-info
                {:name ::global-fields-settings-main/edit
                 :view global-fields-settings-main/edit
                 :controllers [(global-fields-settings-main/form-controller)]})]]]

      ["/projects/:project-id"
       ["/histories"
        (merge base-info
               {:name        ::project-history/index
                :title       "Project History"
                :force-reload? true
                :view        (fn [match] [#'project-history/index])
                :controllers [project-history/main-controller]})]

       ["/permutations/new"
        (merge base-info
               {:name ::permutations-main/new
                ;; Force reloading of page even if navigated in SPA mode, because otherwise DB would not
                ;; be initialized correctly for legacy permutations/kanban/search
                :force-reload? true
                :view permutations-main/permutations-view})]

       ["/search"
        (merge base-info
               {:name ::search-main/index
                :force-reload? true
                :view search-main/search-view})]

       ["/custom_fields"
        ["/new"
         (merge base-info
                {:name ::project-fields-settings-main/new
                 :force-reload? true
                 :view project-fields-settings-main/new
                 :controllers [(project-fields-settings-main/form-controller)]})]
        ["/:custom-field-id/edit"
         (merge base-info
                {:name ::project-fields-settings-main/edit
                 :force-reload? true
                 :view project-fields-settings-main/edit
                 :controllers [(project-fields-settings-main/form-controller)]})]]

       ["/sections"
         (merge base-info
                {:name ::sections/index
                 :title "Sections"
                 :view sections/index})]]

     ["/p/:project-id"
      ["" (assoc base-info
            :name :project-home
            :conflicting true)]

      ["/kanban"
       (merge base-info
              {:name ::kanban-main/board
               :force-reload? true
               :view kanban-main/kanban-view
               :controllers [kanban-main/main-controller]})]

      ["/reports"
       (merge base-info
              {:name ::reports-main/index
               :force-reload? true
               :view reports-main/reports-view
               :controllers [reports-main/main-controller]})]

      ["/system_fields/:system-field-id/edit"
       (merge base-info
              {:name ::project-fields-settings-main/system-field-edit
               :force-reload? true
               :view project-fields-settings-main/system-field-edit
               :controllers [(project-fields-settings-main/system-field-form-controller)]})]

      ;; Milestones
      (let [base-info (assoc base-info :entity :milestone)]
        ;; /p/:project-id/milestones
        ["/milestones"
         [""
          (merge base-info
                 {:name        ::milestones/index
                  :title       "Milestones"
                  :view        (fn [match]
                                 [#'milestones/index])
                  :controllers [milestones/main-controller]})]

         ["/new"
          (assoc base-info
            :name ::milestones/new
            :title "New Milestone"
            :view (fn [match]
                    [#'milestones/main true])
            :controllers [(milestones/new-controller)])]

         ["/:milestone-id"
          ["/edit"
           (assoc base-info
             :name ::milestones/edit
             ;; Title is managed in `got-entity` handler due to dependency on entity data
             :view (fn [match]
                     [#'milestones/main false])
             :controllers [(milestones/edit-controller)])]]])
      ;;
      ;; Requirements
      (let [base-info (assoc base-info :entity :requirement)
            index-route (merge base-info
                               {:name        ::requirements-index/index
                                :title       "Requirements"
                                :view        (fn [match]
                                               [#'requirements-index/index])
                                :conflicting true
                                :controllers [requirements-index/main-controller]})]
        ;; /p/:project-id/requirements
        ["/requirements"
         ["" index-route]
         ;; Support both /requirements and /requirements/ paths
         ["/" (assoc index-route
                  ;; Can't have two routes with same name
                     :name ::requirements-index/index2)]
         ["/new"
          (assoc base-info
            :name ::requirements/new
            :title "New Requirement"
            :view (fn [_]
                    [#'requirements/main true])
            :controllers [requirements/new-controller])]

         ["/:requirement-id"
          ["/edit"
           (assoc base-info
             :name ::requirements/edit
             :view (fn [_]
                     [#'requirements/main false])
             :controllers [requirements/edit-controller])]]])

      ;; Testsets - support for new UI
      (let [base-info (assoc base-info :entity :testset)
            index-route (merge base-info
                               {:name        ::testset-index/index
                                :title       "Test Sets"
                                :view        (fn [match]
                                               [#'testset-index/index])
                                :conflicting true
                                :controllers [testset-index/main-controller]})]
        ;; /p/:project-id/sets
        ["/sets"
         ["" index-route]
         ;; Support both /sets and /sets/ paths

         ["/" (assoc index-route
                  ;; Can't have two routes with same name
                     :name ::testset-index/index2)]

         ["/new"
          (assoc base-info
                 :name ::testset2/new
                 :title "New Test Set"
                 :view (fn [match]
                         [#'testset2/main true])
                 :controllers [(testset2/build-new-controller)])]

         ["/:testset-id"
          ["/edit"
           (assoc base-info
                  :name ::testset2/edit
             ;; Title is managed in `got-entity` handler due to dependency on entity data
             :view (fn [match]
                     [#'testset2/main false])
             :controllers [(testset2/build-edit-controller)])]

          ["/et/:entity-id"
           ["/edit"
            (merge base-info
                   {:name ::et-main/edit
                    :force-reload? true
                    :view et-main/et-view
                    :controllers [et-main/main-controller]})]]

          (when (:new-instance-form? config)
            ;; Instances
            (let [base-info (assoc base-info :entity :instance)]
              ["/instances"
               ["/:instance-id"
                ["/edit"
                 (assoc base-info
                   :name ::instance/edit
                   ;; Title is managed in `got-entity` handler due to dependency on entity data
                   :view (fn [match]
                           [#'instance/main false])
                   :controllers [(instance/build-edit-controller)])]]]))]])

      ;; Two types of URLs for instance form
      (when (:new-instance-form? config)
        ;; Instances
        (let [base-info (assoc base-info :entity :instance)]
          ["/instances"
           ["/:instance-id"
            ["/edit"
             (assoc base-info
               :name ::instance/edit2
               ;; Workaround for issue with ET form redirect - we're forcing full page
               ;; reload so backend redirection logic is triggered for ET runs
               ;; needs better solution because it slows down navigation, but agreed for this workaround for now
               :force-reload? true
               ;; Title is managed in `got-entity` handler due to dependency on entity data
               :view (fn [match]
                       [#'instance/main false])
               :controllers [(instance/build-edit-controller)])]]]))

      (when (:new-run-form? config)
        ;; Runs
        (let [base-info (assoc base-info :entity :run)]
          ["/qtest_runs"
           ["/:run-id"
            ["/edit"
             (assoc base-info
               :name ::run/edit
               :view (fn [match]
                       [#'run/main false])
               :controllers [(run/build-edit-controller)])]]]))

       ;; Tests - support for new UI
       (let [base-info (assoc base-info :entity :test)
             index-route (merge base-info
                                {:name        ::tests-index/index
                                 :title       "Tests"
                                 :view        (fn [match]
                                                [#'tests-index/index])
                                 :conflicting true
                                 :controllers [tests-index/main-controller]})]
         ;; /p/:project-id/tests
         ["/tests"
          ["" index-route]
          ;; Support both /tests and /tests/ paths
          ["/" (assoc index-route
                      ;; Can't have two routes with same name
                      :name ::tests-index/index2)]

          ;; Test Entity form
          [["/new"
            (assoc base-info
              :name ::test-form/new
              :title "New Test"
              :conflicting true
              :view (fn [match]
                      [#'test-form/main true])
              :controllers [test-form/new-controller])]

           (let [show-route (assoc base-info
                              :conflicting true
                              :name ::test-form/show
                              :view (fn [match]
                                      [#'test-form/main false])
                              :controllers [test-form/edit-controller])]

             ["/:test-id"
              ["" (assoc show-route :name ::test-form/show)]
              ["/" (assoc show-route :name ::test-form/show2)]
              ["/edit"
               (assoc base-info
                 :name ::test-form/edit
                 ;; Title is managed in `got-entity` handler due to dependency on entity data
                 :view (fn [match]
                         [#'test-form/main false])
                 :controllers [test-form/edit-controller])]])]])

        ;; Issues
        (let [base-info (assoc base-info :entity :issue)
              index-route (merge base-info
                                 {:name        ::issues-index/index
                                  :title       "Issues"
                                  :view        (fn [match]
                                                 [#'issues-index/index])
                                  :conflicting true
                                  :controllers [issues-index/main-controller]})]
          ;; /p/:project-id/issues
          ["/issues"

           ["" index-route]
           ;; Support both /issues and /issues/ paths

           ["/" (assoc index-route
                    ;; Can't have two routes with same name
                       :name        ::issues-index/index2)]

           [["/new"
             (assoc base-info
               :name ::issues/new
               :title "New Issue"
               :conflicting true
               :view (fn [match]
                       [#'issues/main true (:query-params match)])
               :controllers [(issues/new-controller)])]
            ["/:issue-id"
             ["" (assoc base-info
                   :name ::issues/show
                   :conflicting true
                   :view (fn [match]
                           [#'issues/main false nil])
                   :controllers [(issues/edit-controller)])]
             ["/" (assoc base-info
                    :name ::issues/show2
                    :view (fn [match]
                            [#'issues/main false nil])
                    :controllers [(issues/edit-controller)])]
             ["/edit"
              (assoc base-info
                :name ::issues/edit
                ;; Title is managed in `got-entity` handler due to dependency on entity data
                :view (fn [match]
                        [#'issues/main false nil])
                :controllers [(issues/edit-controller)])]]]])]])

   ;; Root route
   {:doc "My root route"}

   ;; Developers sandbox
   (development-only
     ["/dev"
      [""
       {:name :dev-sandbox
        :title "Dev Sandbox"
        :view (resolve 'practitest.dev.sandbox/sandbox-view)}]

      ["/icons"
       {:name :dev-icons
        :title "All Icons"
        :view (resolve 'practitest.frontend.components.icons/all-icons-component)}]

      ["/dndkit"
       {:name :dev-dndkit
        :title "DNDKit sandbox"
        :view (resolve 'practitest.dev.dndkit/dndkit-sandbox)}]])])


;; Removed hot reload call of this function as it was causing on-navigate to fire
;; and controllers to fire as well, sometimes erasing pending state which was really obtrusive
;; One disadvantage is that now you need to reload application after routes and controller changes
;; You can add ^:dev/after-load annotation back if you're more interested in hot-reload of routes and controllers
(defn reload-routes! []
  (router/init! (build-rails-routes @router-configuration)))

(defn ^:export init [config]
  (reset! router-configuration (js->clj config :keywordize-keys true))
  (reload-routes!))
